// exports CampaignStatus - an immutable object 'enum'
// usage: import { CampaignStatus } from '../../enums/CampaignStatus';
const statuses = {
    New: 1,
    Ready: 10
};
Object.freeze(statuses);
export const CampaignStatuses = statuses;